import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/filter/extra-reducers';
import reducers from 'src/redux/filter/reducers';
import { initialFilterState } from './types';

const filtersSlice = createSlice({
  name: 'filters',
  initialState: initialFilterState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const { updateUserFilter, updateRoleFilter, updateVendorFilter } = filtersSlice.actions;

export default filtersSlice.reducer;
